import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { ApiError } from '@/api';
import { notificationsService } from '@/modules/notifications/api/notifications.service';
import { notificationQueryKeys } from '@/modules/notifications/api/notifications.query-key';

/** Mark every notification read, then refresh all notification lists. */
export function useMarkAllReadMutation() {
    const qc = useQueryClient();
    return useMutation<void, ApiError, void>({
        mutationFn: () => notificationsService.markAllRead(),
        onSuccess:  () => { qc.invalidateQueries({ queryKey: notificationQueryKeys.lists() }); },
    });
}
